import { useNavigate } from 'react-router-dom';

import styled from '@emotion/styled';

interface ICompanyLetterLogo {
  className?: string;
}

export const CompanyLetterLogo: React.FC<ICompanyLetterLogo> = ({
  className,
}) => {
  const navigate = useNavigate();

  return (
    <Container
      className={className === 'header' ? className : ''}
      onClick={() => navigate('/')}
    >
      <Img alt="darum" src="/static/svg/company-letter-logo.svg" />
    </Container>
  );
};
const Img = styled.img`
  max-height: 30px;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 9.83231rem; */
  cursor: pointer;

  &.header {
    width: 6.55488rem;
  }
`;
